export default "__VITE_ASSET__DFfyF5PT__"